import React, { useState, useEffect } from 'react';
// 1. Import NavLink alongside Link
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';
import companyLogo from '../Images/SmartlightLogo.png'

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobileMenuOpen]);

  // A helper function to create the className for NavLink
  const getNavLinkClass = ({ isActive }) => {
    return isActive ? 'active-link' : ''; // Use just one class for active state
  };

  return (
    <nav className="navbar">
      {/* Brand logo can remain a regular Link */}
      <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
        <img src={companyLogo} alt="Light Company Logo" className="navbar-logo" />
      </Link>
      
      <button 
        className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
        aria-controls="navbar-menu"
        aria-expanded={isMobileMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      {/* Navigation Menu */}
      <ul 
        id="navbar-menu"
        className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}
      >
        {/* --- THIS IS THE UPDATED PART --- */}
        <li onClick={closeMobileMenu}>
          {/* 2. Use NavLink and apply the className function. Added 'end' prop for home. */}
          <NavLink to="/" className={getNavLinkClass} end>Home</NavLink>
        </li>
        <li onClick={closeMobileMenu}>
          <NavLink to="/services" className={getNavLinkClass}>Services</NavLink>
        </li>
        <li onClick={closeMobileMenu}>
          <NavLink to="/products" className={getNavLinkClass}>Products</NavLink>
        </li>

        <li onClick={closeMobileMenu}>
          <NavLink to="/projects" className={getNavLinkClass}>Projects</NavLink>
        </li>
        <li onClick={closeMobileMenu}>
          <NavLink to="/about" className={getNavLinkClass}>About Us</NavLink>
        </li>
        <li onClick={closeMobileMenu}>
          <NavLink to="/contactus" className={getNavLinkClass}>Contact Us</NavLink>
        </li>

        
        
      </ul>
    </nav>
  );
}